import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App.tsx'
import './index.css'
import { Auth0Provider } from '@auth0/auth0-react'
import { registerServiceWorker } from './utils/pushNotifications'

// Register early so push works after Add to Home Screen / install
if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
  registerServiceWorker().catch(() => {})
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      cacheTime: 1000 * 60 * 30, // 30 minutes
    },
  },
})

const domain = import.meta.env.VITE_AUTH0_DOMAIN
const clientId = import.meta.env.VITE_AUTH0_CLIENT_ID
const redirectUri = import.meta.env.VITE_AUTH0_REDIRECT_URI || window.location.origin
const logoutRedirectUri = import.meta.env.VITE_AUTH0_LOGOUT_REDIRECT_URI || window.location.origin

const onRedirectCallback = (appState: any) => {
  const targetUrl = appState?.returnTo || window.location.pathname;
  window.history.replaceState({}, document.title, targetUrl);
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <QueryClientProvider client={queryClient}>
        <Auth0Provider
          domain={domain}
          clientId={clientId}
          authorizationParams={{
            redirect_uri: redirectUri,
            scope: import.meta.env.VITE_AUTH0_SCOPE || 'openid profile email roles permissions offline_access',
            audience: import.meta.env.VITE_AUTH0_AUDIENCE,
          }}
          cacheLocation="localstorage"
          useRefreshTokens
          useRefreshTokensFallback={true}
          onRedirectCallback={onRedirectCallback}
          skipRedirectCallback={window.location.pathname === '/admin'}
          advancedOptions={{
            defaultScope: 'openid profile email roles permissions offline_access'
          }}
          // This is the key change - merge token info into the user object
          getTokenSilently={(options) => {
            const promise = getTokenSilently(options);
            promise.then((token) => {
              try {
                const base64Url = token.split('.')[1];
                const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
                const jsonPayload = decodeURIComponent(atob(base64).split('').map((c) => {
                  return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
                }).join(''));
                const payload = JSON.parse(jsonPayload);
                if (payload.permissions) {
                  user['https://midwestrailbirds.com/permissions'] = payload.permissions;
                }
              } catch (e) {
                // Token processing failed
              }
            });
            return promise;
          }}
          onAuthenticated={(auth0State) => {
            // Authentication successful
          }}
        >
          <App />
        </Auth0Provider>
      </QueryClientProvider>
    </BrowserRouter>
  </React.StrictMode>
)
